import { flux } from '@/core/flux.module';
import type { ModelInput, ModelPayload } from '@/tools/models/model.store';
import type { ModelOutputV1 } from '@/sdk/model/ModelOutputV1';
import type { ModelType } from '@/tools/models/model.types';
import { MODEL_TYPES } from '@/tools/models/model.types';
import { sqScalingModelStore, sqToolModelStore } from '@/core/core.stores';

export function resetModel(modelType: ModelType) {
  flux.dispatch(`${modelType}_MODEL_RESET_MODEL`);
}

export function setModel(modelType: ModelType, model: ModelPayload | ModelOutputV1) {
  flux.dispatch(`${modelType}_MODEL_SET_MODEL`, { model });
}

export function setFeatureToEditId(modelType: ModelType, featureId: string | undefined) {
  flux.dispatch(`${modelType}_MODEL_SET_FEATURE_TO_EDIT_ID`, { featureToEditId: featureId });
}

export const getModelInputFeatures = (modelType: ModelType): ModelInput[] => {
  if (modelType === MODEL_TYPES.TOOL) {
    return sqToolModelStore.inputFeatures;
  }
  if (modelType === MODEL_TYPES.SCALING) {
    return sqScalingModelStore.inputFeatures;
  }
  return [];
};

export function setInstanceToEditId(modelType: ModelType, instanceToEditId: string | undefined) {
  flux.dispatch(`${modelType}_MODEL_SET_INSTANCE_TO_EDIT_ID`, { instanceToEditId });
}
